import React from 'react';

import './text-question.scss';

/* eslint-disable-next-line */
const TextQuestion = ({ name, header, body, placeholder, value, onChange, type, error, post = (n) => n, disabled }) => (
  <div className="text-question">
    <p className="header">{header}</p>
    <input
      className={!error ? '' : 'error-state'}
      disabled={disabled}
      onChange={e => onChange(name, post(e.target.value))}
      value={value}
      placeholder={placeholder}
      type={type}
    />
    {
      body &&
      <p className="body">{body}</p>
    }
    {
      error && error !== true &&
      <small className="error-text">{error}</small>
    }
  </div>
);

export default TextQuestion;



// WEBPACK FOOTER //
// ./src/components/TextQuestion/index.jsx